import iosBridge from '../../iosBridge/iosBridgeService';
import { showNotification } from './notifications';

const openLinkInNewWindow = (url, target = '_blank') => {
  if (iosBridge.isInitialized()) {
    iosBridge.callHandler('modalTab://open', url);

    return;
  }

  const windowTab = window.open(url, target);

  if (windowTab === null) {
    showNotification({
      title: 'ERROR',
      message: 'Your browser is blocking our pop-up. Please allow pop-ups in your browser to proceed.',
    });

    const link = document.createElement('a');
    document.body.appendChild(link);
    link.href = url;
    link.target = target;
    link.click();
    document.body.removeChild(link);
  } else {
    windowTab.focus();
  }
};

export default openLinkInNewWindow;
